<div>
  <div style="width: 100%;">

    <div class="closeSidenavBtn">
      <a (click)="closeClicked()" class="btn" mat-button>
        <mat-icon>close</mat-icon>
      </a>
      <div class="clearFloat"></div>
    </div>
  </div>
</div>

<div class="leadAuditDetailWrap">
  <pre><p>{{_audit | json}}</p></pre>
</div>
